import { CalendarListChatItemView } from '$tablet-app/src/app/components/CalendarListView/CalendarListHourGroupView';
import TaskListItemChatView from '$tablet-app/src/app/components/TaskListItemChatView';
import React from 'react';
import ChatClockView from './ChatClockItem';
import ChatImageItem from './ChatImageItem';
import ChatOptionsItem from './ChatOptionsItem';
import { ChatRecipesItem } from './ChatRecipesItem';
import ChatTextItem from './ChatTextItem';
import { ChatUserTextItem } from './ChatUserTextItem';
import WeatherChatView from './ChatWeatherItem';
import { ChatItem as ChatItemType, ChatItemTypes } from './types';

interface ChatItemProps {
  /** The chat item to render */
  item: ChatItemType;
  /** The idx of the chat item. Useful for update the item */
  idx: number;

  dont_show_icon_options?: boolean;

  /** Handles the selection of option chat type */
  onSelectOption?: (input: string, itemIdx: number) => void;

  onClose?(): void;
}
/**
 * Higher order component for handling which chat item to render
 * based on the item type
 */
const ChatItem = (props: ChatItemProps) => {
  const { item, idx, dont_show_icon_options, onClose } = props;

  switch (item.type) {
    case ChatItemTypes.USER:
      return <ChatUserTextItem item={item} />;
    case ChatItemTypes.TEXT:
      return (
        <ChatTextItem
          idx={idx}
          dont_show_icon_options={dont_show_icon_options}
          item={item}
          onPressOption={props.onSelectOption}
        />
      );
    case ChatItemTypes.OPTIONS:
      return (
        <ChatOptionsItem
          description={item.data.description}
          options={item.data.options}
          selectedIdx={item.data.selected}
          onSelect={(input) => props.onSelectOption?.(input, idx)}
        />
      );
    case ChatItemTypes.IMAGE:
      return <ChatImageItem imageSource={item.data.source} />;
    case ChatItemTypes.CHECKLIST:
      return <TaskListItemChatView id={item.data.id} />;
    case ChatItemTypes.WEATHER:
      return <WeatherChatView weather_data={item.data.weather_data} />;

    case ChatItemTypes.CLOCK:
      return (
        <ChatClockView
          location={item.data.location}
          date={item.data.date}
          time={item.data.time}
        />
      );
    case ChatItemTypes.CALENDAR_ITEM:
      return <CalendarListChatItemView items={item.data.items} />;

    case ChatItemTypes.RECIPE_ITEM:
      return <ChatRecipesItem chat_item={item} onClose={onClose} />;

    default:
      return null;
  }
};

export default ChatItem;
